module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"header":{"email":"Email","phone":"Телефон","rentalPoints":"Точки проката"},"error":{"invalidType":"Неверный тип файла!","tooBig":"Максимальный размер загружаемого фото — 64 МБ"}}}')
  delete Component.options._Ctor
}
